import React from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingVertical, responsivePaddingHorizontal, HorizontalPadding } from '../../common/responsive.utils';

const Component07 = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.screen_Web}>
                        <div style={styles.divPadding_Web} >
                            <span style={styles.titleTxt_Web}>
                                이런 고민을 하고 있다면 <br /> 우주펫 파트너를 시작해 보세요
                            </span>
                        </div>

                        <div style={{ height: "6.2500vh" }} />

                        <div style={styles.divRow_Web}>

                            <div style={styles.content_Web}>

                                <span style={styles.contentTitleTxt_Web}>
                                    💸  &nbsp; 예약 프로그램 비용이 부담돼요.
                                </span>

                                <div style={{ height: "1.25vh" }} />
                                <span style={styles.contentTxt_Web}>
                                    반려동물 호텔 및 유치원을 운영중인 사장님이라면 <br />
                                    누구나 <span style={styles.textBold_Web}>예약 관리 서비스를 무료</span>로 이용할 수 있어요!
                                </span>

                            </div>

                            <div style={{ height: "3.125vh" }} />

                            <div style={styles.content_Web}>

                                <span style={styles.contentTitleTxt_Web}>
                                    🎯  &nbsp; 광고 비용 대비 효과가 낮아 고민이에요.
                                </span>

                                <div style={{ height: "1.25vh" }} />
                                <span style={styles.contentTxt_Web}>
                                    호텔∙유치원을 찾는 반려인만 모여 있어 다른 서비스보다 <br />
                                    <span style={styles.textBold_Web}>정확한 타깃에게 도달</span>하여  <span style={styles.textBold_Web}>광고 효율을 높일 수 있어요.</span>
                                </span>

                            </div>

                        </div>

                        <div style={{ height: "3.125vh" }} />


                        <div style={styles.divRow_Web}>
                            <div style={styles.content_Web}>

                                <span style={styles.contentTitleTxt_Web}>
                                    🏪 &nbsp; 오픈한지 오래됐지만 인지도가 낮아요.
                                </span>

                                <div style={{ height: "1.25vh" }} />
                                <span style={styles.contentTxt_Web}>
                                    <span style={styles.textBold_Web}> 리스트 상단에 내 매장이 노출</span>되어 다른 매장보다 <br />
                                    <span style={styles.textBold_Web}>더 많은 고객에게 주목</span>받을 수 있어요.
                                </span>

                            </div>

                            <div style={{ height: "3.125vh" }} />

                            <div style={styles.content_Web}>

                                <span style={styles.contentTitleTxt_Web}>
                                    🙋🏻‍♂️ &nbsp; 새로운 고객을 확보하고 싶어요.
                                </span>

                                <div style={{ height: "1.25vh" }} />
                                <span style={styles.contentTxt_Web}>
                                    돌봄이 필요한 반려인에게 <span style={styles.textBold_Web}>돌봄 제안</span>을 보내 <br />
                                    내 매장을 이용할 <span style={styles.textBold_Web}>고객을 직접 데려올 수 </span>있어요.
                                </span>

                            </div>
                        </div>

                    </div>
                </>
            ) : (
                <>
                    <div style={styles.screen_Mobile}>
                        <span style={styles.titleTxt_Mobile}>
                            이런 고민을 하고 있다면 <br />
                            우주펫 파트너를 시작해 보세요
                        </span>

                        <div style={{ height: "4.25vh" }} />

                        <div style={styles.content_Mobile}>
                            <div style={styles.iconCon_Mobile}>
                                <span style={styles.contentTitleTxt_Mobile}>
                                    💸 &nbsp; 예약 프로그램 비용이 부담돼요.
                                </span>
                            </div>

                            <div style={{ height: "1vh" }} />

                            <span style={styles.contentTxt_Mobile}>
                                반려동물 호텔 및 유치원을 운영중인 사장님이라면 누구나 <span style={styles.textStyBold_Mobile}>예약 관리 서비스를 무료</span>로 이용할 수 있어요!
                            </span>
                        </div>

                        <div style={{ height: "3vh" }} />

                        <div style={styles.content_Mobile}>
                            <div style={styles.iconCon_Mobile}>
                                <span style={styles.contentTitleTxt_Mobile}>
                                    🎯 &nbsp; 광고 비용 대비 효과가 낮아 고민이에요.
                                </span>
                            </div>

                            <div style={{ height: "1vh" }} />

                            <span style={styles.contentTxt_Mobile}>
                                호텔∙유치원을 찾는 반려인만 모여 있어 <br />
                                다른 서비스보다 <span style={styles.textStyBold_Mobile}>정확한 타깃에게 도달</span>하여 <br />  <span style={styles.textStyBold_Mobile}>광고 효율을 높일 수 있어요.</span>
                            </span>
                        </div>

                        <div style={{ height: "3vh" }} />

                        <div style={styles.content_Mobile}>
                            <div style={styles.iconCon_Mobile}>
                                <span style={styles.contentTitleTxt_Mobile}>
                                    👀 &nbsp; 오픈한지 오래됐지만 인지도가 낮아요.
                                </span>
                            </div>

                            <div style={{ height: "1vh" }} />

                            <span style={styles.contentTxt_Mobile}>
                                <span style={styles.textStyBold_Mobile}>리스트 상단에 내 매장이 노출</span>되어 <br />
                                다른 매장보다 <span style={styles.textStyBold_Mobile}>더 많은 고객에게 주목</span>받을 수 있어요.
                            </span>
                        </div>

                        <div style={{ height: "3vh" }} />

                        <div style={styles.content_Mobile}>
                            <div style={styles.iconCon_Mobile}>
                                <span style={styles.contentTitleTxt_Mobile}>
                                    📢 &nbsp; 새로운 고객을 확보하고 싶어요.
                                </span>
                            </div>

                            <div style={{ height: "1vh" }} />

                            <span style={styles.contentTxt_Mobile}>
                                돌봄이 필요한 반려인에게 <span style={styles.textStyBold_Mobile}>돌봄 제안</span>을 보내 <br />
                                내 매장을 이용할 <span style={styles.textStyBold_Mobile}>고객을 직접 데려올 수</span> 있어요.
                            </span>
                        </div>

                    </div>
                </>
            )}
        </>
    );
}


const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: { backgroundColor: "#F9F5FF", display: "flex", flexDirection: "column", boxSizing: "border-box", paddingBottom: responsivePaddingVertical(50, 110), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88)},
    titleTxt_Web: { fontFamily: "Pretendard", fontWeight: 800, fontSize: responsiveFont(22, 40), letterSpacing: "-1%", color: "#1B1D1F", lineHeight: "120%" },
    content_Web: { width: "765px", height: "199px", paddingBottom: responsivePaddingVertical(24, 38), paddingTop: responsivePaddingVertical(20, 34), paddingLeft: HorizontalPadding(20, 40), paddingRight: HorizontalPadding(20, 40), marginRight: "35px", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "center", backgroundColor: "white", borderRadius: "10px" },
    contentTitleTxt_Web: { fontFamily: "Pretendard", fontWeight: 700, fontSize: responsiveFont(16, 28), letterSpacing: "-3%", alignSelf: "flex-start", color: "#1B1D1F", lineHeight: "140%" },
    contentTxt_Web: { fontFamily: "Pretendard", fontWeight: 400, fontSize: responsiveFont(14, 24), letterSpacing: "-3%", alignSelf: "flex-start", color: "#454A50", lineHeight: "140%" },
    textBold_Web: { fontFamily: "Pretendard", fontWeight: 600, fontSize: responsiveFont(14, 24), letterSpacing: "-3%", alignSelf: "flex-start", color: "#454A50", lineHeight: "140%" },
    divPadding_Web: { paddingLeft: responsivePaddingHorizontal(24, 88), marginBottom: "20px" },
    divRow_Web: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" },

    screen_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "#f9f5ff", display: "flex", flexDirection: "column", boxSizing: "border-box", paddingBottom: responsivePaddingVertical(50, 110), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88)},
    titleTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: "-3%", alignSelf: "flex-start", lineHeight: "140%" },
    content_Mobile: { width: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "center", backgroundColor: "white", borderRadius: "10px", paddingBottom: responsivePaddingVertical(24, 38), paddingTop: responsivePaddingVertical(20, 34), paddingLeft: HorizontalPadding(20, 40), paddingRight: HorizontalPadding(20, 40)},
    iconCon_Mobile: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" },
    contentTitleTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(16, 28), fontWeight: 700, letterSpacing: "-3%", alignSelf: "flex-start", color: "black", lineHeight: "140%" },
    contentTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-3%", alignSelf: "flex-start", color: "#454A50", lineHeight: "140%" },
    textStyBold_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: 600, letterSpacing: "-3%", color: "#454A50", lineHeight: "140%" },
});


export default Component07;